import getOneBundle, { BUNDLE_SMALL_NAME } from "../../BundleResourceConfig";
import { getOnePeopleById } from "../../config/WeChatPeopleConfig";
import {  NormalEvent_New } from "../../manager/DefineInterface";
import { WeChatPeople } from "../../manager/WeChatConst";
import normalMode from "../../normalMode";
import normalEventNewBase from "./normalEventNewBase";

const {ccclass, property} = cc._decorator;

@ccclass
export default class normalEventNew extends normalEventNewBase {

    @property({type:cc.Label,displayName:"名字文本"})
    lbName:cc.Label = null;

    @property({type:cc.Node,displayName:"单行文本背景节点"})
    oneRowNode:cc.Node = null;

    @property({type:cc.Node,displayName:"多行文本背景节点"})
    multilineRowNode:cc.Node = null;

    @property({type:cc.Node,displayName:"头像背景节点"})
    headBgNode:cc.Node = null;

    @property({type:cc.Node,displayName:"名字节点"})
    nameNode:cc.Node = null;

    @property({type:cc.Node,displayName:"content节点"})
    contentNode:cc.Node = null;

    @property({type:cc.Node,displayName:"frameNode节点"})
    frameNode:cc.Node = null;

    eventData:NormalEvent_New = null;

    isStart:boolean = true;

    startData:NormalEvent_New = <NormalEvent_New>{};

    gameLayer:normalMode = null;

    iconInitX:number = 0;

    headBgInitX:number = 0;

    nameInitX:number = 0;

    complete ?: ()=>void;
    
    start(){
        super.start();
        this.iconInitX = this.headSp.x;
        this.headBgInitX = this.headBgNode.x;
        this.nameInitX = this.nameNode.x;
        this.eventAni();
    }

    eventAni(){
        this.headSp.x -= 375;
        this.headBgNode.x -= 375;
        this.nameNode.x -= 375;

        let needTime:number = 1.5;

        cc.tween(this.headBgNode).to(needTime,{x:this.headBgInitX},{easing:cc.easing.backOut}).start();
        cc.tween(this.nameNode).to(needTime,{x:this.nameInitX},{easing:cc.easing.backOut}).start();
        cc.tween(this.headSp).delay(0.2).to(needTime,{x:this.iconInitX},{easing:cc.easing.backOut}).start();
        this.oneRowNode.scale = 0;
        this.multilineRowNode.scale = 0;

        let scaleNeedTime:number = 0.2;

        cc.tween(this.oneRowNode).delay(needTime + 0.5).to(scaleNeedTime,{scale:1}).to(0.1,{scale:1},{easing:cc.easing.backOut}).start();
        cc.tween(this.multilineRowNode).delay(needTime + 0.5).to(scaleNeedTime,{scale:1}).to(0.1,{scale:1},{easing:cc.easing.backOut}).start();

        this.scheduleOnce(()=>{
            this.updateChoose();
        },needTime + 0.5 + scaleNeedTime + 0.1);
    }

    bindEvent(id:string | number,gameLayer:normalMode,complete?:()=>void){
        super.bindEvent(id,gameLayer,complete);
        this.updateDialog();
    }

    updateDialog(){
        let s = /[\u4e00-\u9fa5|\u3002|\uff1f|\uff01|\uff0c|\u3001|\uff1b|\uff1a|\u201c|\u201d|\u2018|\u2019|\uff08|\uff09|\u300a|\u300b|\u3008|\u3009|\u3010|\u3011|\u300e|\u300f|\u300c|\u300d|\ufe43|\ufe44|\u3014|\u3015|\u2026|\u2014|\uff5e|\ufe4f|\uffe5]/
        let maxLength:number = 22;
        let currentLength:number = 0;
        let eventStr:string = this.eventData.eventExplain;
        let rowLength:number = 1;
        for(let i = 0;i<eventStr.length;i++){
            let ss = eventStr[i];
            let isTrue = s.test(ss);
            if(isTrue){
                if(currentLength + 2 <= maxLength){
                    currentLength += 2;
                }else{
                    rowLength ++;
                    currentLength = 2;
                }
            }else{
                if(currentLength + 1 <= maxLength){
                    currentLength += 1;
                }else{
                    rowLength ++;
                    currentLength = 1;
                }
            }
        }
        this.oneRowNode.scale = 0;
        this.multilineRowNode.scale = 0;
        if(rowLength < 2){
            this.oneRowNode.active = true;
            this.multilineRowNode.active = false;
            this.multilineRowNode.width = currentLength * this.lb_Dec.fontSize / 2 + 75;
        }else{
            this.oneRowNode.active = false;
            this.multilineRowNode.active = true;
            this.multilineRowNode.height = rowLength * this.lb_Dec.lineHeight + 50;
        }
    }

    async loadEvent(){
        let peopleId = this.eventData.peopleId;
        let people:WeChatPeople = getOnePeopleById(peopleId);
        let headUrl:string = null;
        if(people){
            headUrl = people.name;
        }
        this.lbName.string = people.name;
        this.headSp.getComponent(cc.Sprite).spriteFrame = null;
        this.lb_Dec.string = "";
        if(headUrl){
            getOneBundle(BUNDLE_SMALL_NAME.eventGameBundle).then((bundle:cc.AssetManager.Bundle)=>{
                bundle.load(`assets/eventHead/${headUrl}`,cc.SpriteFrame,(err,asset:cc.SpriteFrame)=>{
                    if(err){
                        console.log(err);
                    }else{
                        this.headSp.getComponent(cc.Sprite).spriteFrame = asset;
                    }
                });
            });
        }
        this.spNode.active = false;
    }

    closeAni(){
        let scaleTime:number = 0.2;
        this.chooseNode.children.forEach((n:cc.Node)=>{
            cc.tween(n).to(scaleTime,{scale:0}).start();
        });
        cc.tween(this.frameNode).to(scaleTime,{scale:0},{easing:cc.easing.backIn}).start();
        cc.tween(this.contentNode).delay(scaleTime).to(1,{opacity:100,x:375}).start();
        this.scheduleOnce(()=>{
            this.node.destroy();
            this.node.removeFromParent();
        },scaleTime + 0.5);
    }

}
